import React from "react";
import {
  Button,
  makeStyles,
  Menu,
  MenuItem,
  Typography,
} from "@material-ui/core";
import ThreeDotIcon from "../assets/icons/threedot.svg";
import UnbindIcon from "../assets/icons/unbindIcon.svg";

export const ThreeDotMenuItem = (props: any) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const classes = useStyles();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        style={{ width: 24, height: 40, alignSelf: "self-end" }}
      >
        <img
          src={ThreeDotIcon}
          className={classes.icon}
          alt="TradeKart blockIcon"
        />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        className={classes.menu}
      >
        {props.threeDotMenuItems.map((menuItem: any, index: any) => (
          <MenuItem
            key={index}
            onClick={() => {
              menuItem.callback(props.itm);
            }}
            className={classes.menuItem}
          >
            <img
              src={UnbindIcon}
              className={classes.unbindIcon}
              alt="TradeKart blockIcon"
            />
            <Typography
              variant="body2"
              component="span"
              color="error"
              style={{ fontWeight: 600, marginRight: 12 }}
            >
              {menuItem.name}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

const useStyles = makeStyles({
  component: {
    display: "flex",
    flexDirection: "column",
  },
  icon: {},
  menu: {
    marginTop: 48,
  },
  menuItem: {
    marginTop: 24,
    marginBottom: 24,
    paddingTop: 12,
    paddingBottom: 12,
    paddingRight: 12,
  },
  unbindIcon: {
    marginRight: 16,
  },
  threeDot: {
    width: 3,
    height: 3,
    borderRadius: "50%",
    backgroundColor: "grey",
    boxShadow: "0px 5px 0px grey, 0px 10px 0px grey",
  },
  cardImage: {
    borderRadius: 5,
    marginRight: 15,
  },
});
